import { $themeBreakpoints } from '@themeConfig'
import router from '@/router'
import axios from '@/libs/axios'
import toastification from '@/libs/toastification'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    isAdmin: false,
    isUserAdmin: true,
    pageTitle: '',
    settings: {
      footer: {
        phone: '',
        contact_link: 'https://telkom.co.id',
        copyright: `© ${new Date().getFullYear()} DSS PT. Telekomunikasi Indonesia, Tbk. All rights Reserved`,
      },
      logo: {
        menu: '/img/catalog_logo.png',
        footer: '/img/logotelkomindo.png',
        loginBanner: '',
        loginLogo: ''
      },
    },
    modalNPSElement: null,
    notifNPSShowed: false,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    editorOptions: () => {
      return {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction

            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ['clean'],
            ['image'],
          ],
        },
        theme: 'snow',
      }
    },
    axiosConf: () => {
      return {
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    CHANGE_DISPLAY(state) {
      state.isAdmin = !state.isAdmin
      if (state.isAdmin) {
        localStorage.setItem('current_display', 'admin')
        router.push({ name: 'admin-dashboard' })
      } else {
        localStorage.removeItem('current_display')
        router.push({ name: 'home' })
      }
    },
    CHECK_DISPLAY_ADMIN(state) {
      if (window.location.pathname.substring(1,6) === 'admin') {
        state.isAdmin = true
      } else {
        state.isAdmin = false
      }
    },
    SET_IS_ADMIN(state, val) {
      state.isAdmin = val
    },
    SET_PAGE_TITLE(state, val) {
      state.pageTitle = val
    },
    SET_FOOTER(state, val) {
      state.settings.footer = val
    },
    SET_LOGO(state, val) {
      state.settings.logo = val
    },
    setModalNPSElement(state, val) {
      state.modalNPSElement = val
    },
    setStatusNotifNPS(state, val) {
      state.notifNPSShowed = val
    }
  },
  actions: {
    search(context, payload) {
      window.clearTimeout(window.timeOutId)
      window.timeOutId = window.setTimeout(function() {
        if (typeof payload.callback === 'function') {
          payload.callback()
        }
      }, 500)
    },
    fetchGlobalSettings({ commit }) {
      axios.get('/settings').then(({ data }) => {
        commit('SET_FOOTER', data.footer)
        commit('SET_LOGO', data.logo)
      })
    },
    checkShowNPSRate({ state, commit }) {
      return axios.get('/rating/my/check')
      .then((res) => {
        let data = res.data.data.records
        if (data.length < 1 && !state.notifNPSShowed) {
          toastification.notifOnClick(
            'Rate App!', 
            "You haven't rate this app yet. You can rating this app by click button.", 
            'danger', 
            'AlertTriangleIcon', 
            'danger', 
            'Rate this app', 
            //callback when button clicked
            () => {
              try {
                state.modalNPSElement.show()
                commit('setStatusNotifNPS', false)
              } catch (error) {
              }
            },
            //callback when close button clicked
            () => {
              commit('setStatusNotifNPS', false)
            }
          )
          commit('setStatusNotifNPS', true)
        }
      })
    },
  },
}
